let _ = t => t,
  _t;
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import styledWithTheme from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPanel = styledWithTheme.div(_t || (_t = _`
  position: fixed;
  background-color: ${0};
  inset: 0;
  z-index: 1111;
  contain: content;
  transform: ${0};
  transition: transform 0.3s ease;
`), ({
  theme
}) => theme.color['fill-surface-default'], ({
  isOpen
}) => isOpen ? 'translateY(0)' : 'translateY(100%)');
export const FullScreenPanel = ({
  children,
  isOpen,
  onRemoveButtonClick,
  title
}) => {
  return /*#__PURE__*/_jsxs(StyledPanel, {
    isOpen: isOpen,
    role: "dialog",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: title ? 'space-between' : 'end',
      padding: "400",
      children: [title, /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "close-button",
        onClick: onRemoveButtonClick,
        use: "unstyled",
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })]
    }), /*#__PURE__*/_jsx(View, {
      borderBlockStartColor: "border-core-default",
      borderBlockStartStyle: "solid",
      borderBlockStartWidth: "100",
      paddingBlockStart: "600",
      paddingInline: "1000",
      children: children
    })]
  });
};